<template>
    <div class="pay-container">
        <head-bar title="支付订单" :fixed="true"></head-bar>
        <div class="info-box">
            <div class="info-item">
                <span>订单号:&nbsp;{{ orderInfo.orderNumber }}</span>
            </div>
            <div class="info-item">
                <span>应付金额:&nbsp;</span>
                <em>¥{{ orderInfo.orderPrice }}</em>
            </div>
            <div class="info-item">
                <span>剩余支付时间:&nbsp;</span>
                <em>{{ times }}</em>
            </div>
        </div>
        <div class="pay-type-box">
            <div class="pay-type-item" @click="wechatPay">
                <i class="base-icon wechat-icon"></i>
                <span>微信支付</span>
            </div>
            <div class="pay-type-item" @click="aliPay" v-if="!$isBuildWechat">
                <i class="base-icon alipay-icon"></i>
                <span>支付宝支付</span>
            </div>
        </div>
        <div class="ali-pay-form" v-show="hideForm" ref="aliPay"></div>
    </div>
</template>
<script>
import Vue from "vue";
import initWxSdk from "@/utils/wechat_sdk.js";
import HeadBar from "@/components/HeadBar.vue";
import utils from "@/utils/utils";
import { Toast, Dialog } from "vant";
import { isEmpty } from "../../utils/validation";
Vue.use(Toast);
import {
    online_payment,
    offline_payment,
    wallet_payment,
    trade_wechat,
    trade_ali,
    trade_bank,
    trade_remittance,
    trade_wallet,
} from "../../definition/type/pay";
export default {
    name: "PayOnline",
    components: {
        HeadBar,
    },
    created() {
        let { orderNo, orderPrice, reload } = this.$route.query;
        if (!orderNo) {
            this.$router.push("/");
            return false;
        }
        if (!reload) {
            window.location.replace(
                `/pay/online?orderNo=${orderNo}&orderPrice=${orderPrice}&reload=1`
            );
        }
        this.orderInfo.orderPrice = orderPrice;
        this.orderInfo.orderNumber = orderNo;
        this.queryOrderCountDown(orderNo);
    },
    beforeMount() {},
    data() {
        return {
            orderInfo: {
                orderNumber: "",
                orderPrice: 0,
            },
            times: "00:00:00",
            hideForm: true,
            isLoad: false,
        };
    },
    methods: {
        /**
         * @description 查询订单倒计时
         */
        queryOrderCountDown(orderNo) {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let url = this.$api.orderApi.order_getOrderCancelTime;
            let _this = this;
            this.$axios
                .post(url, {
                    orderNo: orderNo,
                })
                .then((response) => {
                    let { data: seconds = 0 } = response;
                    utils.countDownConversion(seconds, (times, isEnd) => {
                        _this.times = times;
                        if (isEnd) {
                            _this.$router.push("/");
                        }
                    });
                })
                .catch(() => {
                    _this.$router.push("/");
                })
                .finally(() => {
                    _this.$toast.clear();
                });
        },
        /**
         * @description 微信支付
         */
        wechatPay() {
            let _this = this;
            if (this.isLoad) return;
            if (utils.isPcBrowser()) {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "请在手机上进行支付",
                    confirmButtonColor: "#4BC227",
                })
                    .then(() => {
                        _this.$router.push("/");
                    })
                    .catch(() => {});
                return false;
            }

            let { orderNo, orderPrice = 0 } = this.$route.query;

            let payType = pay_type_wechat;

            const redirect_url = `${_this.$config.WEB_DOMAIN_NAME}user/order/detail?orderNo=${orderNo}`;

            const pay_type_wechat = 13;

            const pay_type_h5 = 14;
            //未授权code
            const undelegated_code = 900;

            if (_this.$isBuildWechat) {
                payType = pay_type_wechat;
            } else {
                payType = pay_type_h5;
            }

            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });

            let updatePayTypeUrl = this.$api.orderApi.order_updatePayType;

            let getPayInfoUrl = this.$api.payApi.pay_getPayInfo;

            this.isLoad = true;

            this.$axios
                .post(updatePayTypeUrl, {
                    orderNo: orderNo,
                    payType: online_payment,
                    payTradeType: trade_wechat,
                })
                .then(() => {
                    _this.$axios
                        .post(getPayInfoUrl, {
                            payType: payType,
                            orderNo: orderNo,
                            payAmount: orderPrice,
                            successUrl: redirect_url,
                            failedUrl: redirect_url,
                        })
                        .then((res) => {
                            _this.$toast.clear();
                            let { code, data } = res;
                            if (_this.$isBuildWechat) {
                                let payInfo = JSON.parse(data);
                                let path = _this.$route.fullPath;
                                let {
                                    appId,
                                    nonceStr,
                                    packageStr,
                                    paySign,
                                    signType,
                                    timeStamp,
                                } = payInfo;
                                initWxSdk(path, (wx) => {
                                    wx.chooseWXPay({
                                        timestamp: timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                                        nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
                                        package: packageStr, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                                        signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                                        paySign: paySign, // 支付签名
                                        success: function(res) {
                                            _this.$router.push({
                                                path: "/pay/success",
                                                query: {
                                                    orderNo: orderNo,
                                                },
                                            });
                                        },
                                    });
                                });
                            } else {
                                let payUrl = res.data;
                                window.open(`${payUrl}`, "_self");
                                Dialog.confirm({
                                    title: "提示",
                                    message: "是否已经完成支付?",
                                    confirmButtonColor: "#4BC227",
                                })
                                    .then(() => {
                                        _this.$router.push("/user/self");
                                    })
                                    .catch(() => {});
                            }
                        })
                        .catch((res) => {
                            let { code, msg } = res;
                            if (code == undelegated_code) {
                                Dialog.confirm({
                                    title: "提示",
                                    message:
                                        "微信支付必须绑定微信,是否现在去绑定",
                                    confirmButtonColor: "#4BC227",
                                })
                                    .then(() => {
                                        _this.$router.push("/user/setting");
                                    })
                                    .catch(() => {});
                            } else {
                                _this.$toast.clear();
                                if (!isEmpty(msg)) {
                                    _this.$toast(msg);
                                }
                            }
                        })
                        .finally(() => {
                            _this.isLoad = false;
                        });
                })
                .catch(({ msg }) => {
                    _this.isLoad = false;
                    _this.$toast.clear();
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                });
        },
        aliPay() {
            let _this = this;
            if (utils.isPcBrowser()) {
                Dialog.confirm({
                    title: "温馨提示",
                    message: "请在手机上进行支付",
                    confirmButtonColor: "#4BC227",
                })
                    .then(() => {
                        _this.$router.push("/");
                    })
                    .catch(() => {});
                return false;
            }
            let { orderNo, orderPrice } = this.$route.query;
            const pay_type_ali = 15;
            const redirect_url = `${_this.$config.WEB_DOMAIN_NAME}user/order/detail?orderNo=${orderNo}`;
            let updatePayTypeUrl = this.$api.orderApi.order_updatePayType;
            let getPayInfoUrl = this.$api.payApi.pay_getPayInfo;
            this.isLoad = true;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(updatePayTypeUrl, {
                    orderNo: orderNo,
                    payType: online_payment,
                    payTradeType: trade_ali,
                })
                .then(() => {
                    _this.$axios
                        .post(getPayInfoUrl, {
                            orderNo: orderNo,
                            payType: pay_type_ali,
                            payAmount: orderPrice,
                            successUrl: redirect_url,
                            failedUrl: redirect_url,
                        })
                        .then((res) => {
                            _this.$toast.clear();
                            let { code, data } = res;
                            let payForm = data;
                            Dialog.confirm({
                                title: "提示",
                                message: "是否已经完成支付?",
                                confirmButtonColor: "#4BC227",
                            })
                                .then(() => {
                                    _this.$router.push("/user/self");
                                })
                                .catch(() => {});
                            _this.$refs.aliPay.innerHTML = payForm;
                            document.forms.punchout_form.submit();
                        })
                        .catch(({ msg }) => {
                            _this.$toast.clear();
                            if (!isEmpty(msg)) {
                                _this.$toast(msg);
                            }
                        })
                        .finally(() => {
                            _this.isLoad = false;
                        });
                })
                .catch(({ msg }) => {
                    _this.$toast.clear();
                    _this.isLoad = false;
                    if (!isEmpty(msg)) {
                        _this.$toast(msg);
                    }
                });
        },
    },
};
</script>
<style lang="less" scoped>
.pay-container {
    width: 750px;
    padding-top: 92px;
    .info-box {
        padding: 60px 40px;
        background-color: #fff;
        .info-item {
            margin-bottom: 5px;
            font-size: 28px;
            line-height: 40px;
            color: #333;
        }
        em {
            font-weight: 600;
            color: #ff5500;
        }
    }
    .pay-type-box {
        margin: 20px 0px;
        padding: 0 30px;
        background-color: #fff;
        .pay-type-item {
            height: 110px;
            border-bottom: 1px solid #f2f2f2;
            font-size: 0px;
            line-height: 110px;
            text-align: center;
            &:last-child {
                border: none;
            }
            .base-icon {
                *display: inline;
                display: inline-block;
                zoom: 1;
                margin-right: 20px;
                vertical-align: -20px;
                width: 56px;
                height: 56px;
                background-size: 56px;
                background-repeat: no-repeat;
                background-position: center;
                &.wechat-icon {
                    background-image: url("../../public/images/pay/wechat-pay-icon.png");
                }
                &.alipay-icon {
                    background-image: url("../../public/images/pay/alipay-pay-cion.png");
                }
            }
            span {
                font-size: 28px;
                color: #333;
            }
        }
    }
}
</style>
